import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { IDepartmentDropdown } from "../../models/IDropdown";
import { JVDropdown } from "../../shared/JVDropdown";

export interface ITicketSub {
    subject_ID?: number,
    ticket_Sub?: string,
    department_ID?: number,
    department_Name?: string,
    createdBy?: number,
    user_Name?: string,
    createdOn?: Date
}

export const EmptyTicketSub: ITicketSub = {
    subject_ID: undefined,
    ticket_Sub: "",
    department_ID: 0
}

const schema = yup.object({
    department_ID: yup.number().min(1, "Department is required*").required("Department is required*"),
    ticket_Sub: yup.string().required("Ticket_Subject is required*"),
});

interface Iprops {
    singleData: ITicketSub,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

export const TicketSub = (props: Iprops) => {
    const [department, setDepartment] = useState<Array<IDepartmentDropdown>>();

    const { control, handleSubmit, formState: { errors }, reset } = useForm<ITicketSub>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    useEffect(() => {
        reset(props.singleData);
    }, [props.singleData]);

    const loadDepartment = async () => {
        const response = await Fetch("Dropdown/department", "GET", null, null, null);
        if (response) {
            const data: Array<IDepartmentDropdown> = await response.json();
            setDepartment(data);
        }
    }

    useEffect(() => {
        loadDepartment();
    }, []);

    const saveToDB = async (body: ITicketSub) => {
        const method = props.singleData.subject_ID ? "PUT" : "POST";
        const message = props.singleData.subject_ID ? "Updated Successfully" : "Added Successfully";

        const response = await Fetch("Ticket/subject", method, body, null, props.toast);

        if (response) {
            onHide();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.setReload(!props.reload);
        }
    }

    const onHide = () => {
        props.hideDialog();
        reset(EmptyTicketSub);
    }

    function onSubmit(data: ITicketSub) {
        saveToDB(data);
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Ticket Subject" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVDropdown required label="Department" control={control} name="department_ID" options={department} optionLabel="department_Name" optionValue="department_ID" placeholder="Select Department" error={errors.department_ID?.message} />
                <JVInput required label="Ticket Subject" control={control} name="ticket_Sub" error={errors.ticket_Sub?.message} />
                <div className="col-12 md:col-12">
                    <Button className="field col-12 md:col-6" label="SAVE" type="submit"></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                </div>
            </form>
        </Dialog>
    );
}
